export enum ScriptSelector {
    ARTISTS = 'artists',
    EVENTS = 'events',
    EVENT_CATEGORIES = 'event-categories',
    LANG_SWITCHER = 'langswitcher',
    MENU = 'menu',
    LOGO = 'logo',
    QUICK_SEARCH = 'quicksearch',
    PROFILE = 'profile',
    PROMOTIONS = 'promotions',
}